module.exports = __webpack_public_path__ + "img/6_26@3x.1f40f9d0.png";